// Dummy card data we want to display for the first card in user's wallet for samsung demo
// To learn about samsung demo project: https://docs.google.com/document/d/11Tx-7Cjdvkm_KscsKEuIeexaart1DX9Kv1uC6MT6cvI/edit?usp=sharing

export const SAMSUNG_DEMO_CARD_ART_URL =
  "https://icm.aexp-static.com/Internet/internationalcardshop/en_sg/images/cards/platinum-card.png";
export const SAMSUNG_DEMO_LAST_FOUR = "8346";

export const SAMSUNG_DEMO_CARD_DESCRIPTION = "American Express Platinum Card®";
